module.exports = __webpack_public_path__ + "img/secondary_1x2.ce31cf5d.svg";